<template>
  <div>
    <el-dialog v-model="feedbackShow" :close-on-click-modal="false" :append-to-body="true" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">意见反馈</div>
        <div class="close_icon cursor_pointer" @click="closePopup">
          <el-icon :size="20">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="flex feedback_title">
          <div class="red_xing">*</div>
          <div class="mar_left_5 contact_information">反馈类型</div>
        </div>
        <div class="radio_box mar_top_5">
          <div class="mt-2">
            <el-checkbox-group v-model="feedbackType">
              <el-checkbox v-for="(item, index) in complaintList" :key="index" :value="item.value" :label="item.label"
                size="large" />
            </el-checkbox-group>
            <!-- <el-checkbox v-model="checked5" label="登录注册" size="large" />
            <el-checkbox v-model="checked6" label="课程学习" size="large" />
            <el-checkbox v-model="checked6" label="课件播放" size="large" />
            <el-checkbox v-model="checked6" label="成绩证书" size="large" />
            <el-checkbox v-model="checked6" label="其他问题和建议" size="large" /> -->
          </div>
        </div>
        <div class="flex feedback_title mar_top_10">
          <div class="red_xing">*</div>
          <div class="mar_left_5 contact_information">反馈内容</div>
        </div>
        <div class="input_box mar_top_20">
          <el-input v-model="feedInfo.feedbackContent" maxlength="150" autosize
            style="width: 100%; height: 150px; background: #f3f3f3;overflow:auto;" placeholder="请输入内容" type="textarea"
            show-word-limit />
        </div>
        <div class="mar_top_20 upload_box">
          <el-upload v-model:file-list="fileList" :action="uploadUrl" list-type="picture-card"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
            <el-icon>
              <Plus />
            </el-icon>
          </el-upload>
        </div>
        <div class="mar_top_20 contact_information">联系方式</div>
        <div class="input_phone mar_top_20">
          <el-input v-model="feedInfo.phone" style="width: 100%; height: 46px" maxlength="11"
            placeholder="请输入手机号便于联系（非必填）" type="text" />
        </div>
        <div class="btn_commit mar_top_20 cursor_pointer" @click="submitFeed">提交</div>
      </div>
    </el-dialog>
    <el-dialog v-model="dialogVisible">
      <img w-full :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as config from "@/config/config";
export default {
  name: "GjkcH5Feedback",

  data() {
    return {
      feedbackShow: false,
      feedInfo: {
        userId: '',
        type: 0,
        feedbackContent: "",
        annex: '',
        phone: "",
        feedbackType:'',
      },
      uploadUrl: "",
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      complaintList: [],  // 反馈类型列表
      feedbackType:[]
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  created(){
    this.getDictList('complaintTypePC');
  },
  mounted() {
    this.uploadUrl = config.COMMON_UPLOAD_URL;
  },

  methods: {
    handlePictureCardPreview(uploadFile) {
      this.dialogImageUrl = uploadFile.url;
      this.dialogVisible = true;
    },
    handleRemove(uploadFile) {
      console.log(uploadFile)
    },
    closePopup() {
      this.feedbackShow = false;
      this.feedInfo = {
        userId: '',
        type: 0,
        feedbackContent: "",
        annex: '',
        phone: "",
        feedbackType:''
      };
      this.fileList = [];
      this.feedbackType = [];
    },
    submitFeed() {
    this.feedInfo.userId = this.userInfo.buyerUserId;
      // 提取图片地址拼接
      this.feedInfo.annex = this.fileList.map(item => {
        return item.response?.data?.url
      }).join(",");
      this.feedInfo.feedbackType = this.feedbackType.join(',');
      if (!this.feedInfo.feedbackContent) {
        this.$Dialog.toast("请输入你要反馈的内容", { type: 'error' });
        return
      }
      if (!this.feedbackType) {
        this.$Dialog.toast("请选择你要反馈的类型", { type: 'error' });
        return
      }
      if (this.feedInfo.phone) {
        if (!/^1[345678]\d{9}$/.test(this.feedInfo.phone)) {
          this.$Dialog.toast("请输入正确的手机号", { type: "error" });
          return;
        }
      }
      this.$Api.common.addFeedBack(this.feedInfo).then(() => {
        this.$Dialog.toast("反馈成功");
        this.closePopup();
      }).catch(() => { })
    },
    // 获取反馈类型字典
    getDictList(type) {
      this.$Api.common.getDictList({dictName:type}).then(res => {
        this.complaintList = res.data.data.map(item => {
          return { label: item.dictName, value: item.dictId }
        });
      }).catch(() => { })
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 508px;
  // height: 730px;
  position: relative;
  padding-bottom: 20px;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  font-weight: 600;
  //   border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
  padding: 0 20px;

  .feedback_title {
    color: #333333;

    .red_xing {
      color: #ea2f15;
    }
  }

  .input_box {
    :deep(.el-textarea__inner) {
      box-shadow: none;
      resize: none;
      padding: 20px;
      box-sizing: border-box;
      background: #f3f3f3;
    }

    :deep(.el-textarea .el-input__count) {
      background: #f3f3f3;
      font-size: 16px;
      bottom: 15px;
    }
  }

  .upload_box {
    :deep(.el-upload--picture-card) {
      width: 80px;
      height: 80px;
    }

    :deep(.el-upload-list--picture-card .el-upload-list__item) {
      width: 80px;
      height: 80px;
    }
  }

  .contact_information {
    font-size: 16px;
    color: #333333;
    // font-weight: 600;
  }

  .input_phone {
    :deep(.el-input__wrapper) {
      box-sizing: border-box;
      background: #f3f3f3;
      box-shadow: none;
    }
  }

  .btn_commit {
    width: 100%;
    height: 52px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 5px;
    line-height: 52px;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
  }
}
</style>